<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">KD ’000</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font black bold" colspan="3">Company</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Short term loans</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">91,110</td>
                            <td class="end font">80,580</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Long term loans</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">562,873</td>
                            <td class="end font">598,535</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">653,983 </td>
                            <td class="end font white font-weight-bold">679,115</td>
                        </tr>
                        <tr>
                            <td class="font black bold" colspan="3">SMTC</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Long term loans</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">310,651</td>
                            <td class="end font">542,804</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">310,651</td>
                            <td class="end font white font-weight-bold">542,804</td>
                        </tr>
                        <tr>
                            <td class="font black bold" colspan="3">Zain Jordan</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Short term loans</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">-</td>
                            <td class="end font">6,622</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Long term loans</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">28,848</td>
                            <td class="end font">-</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">28,848</td>
                            <td class="end font white font-weight-bold">6,622</td>
                        </tr>
                        <tr>
                            <td class="font black bold" colspan="3">Atheer</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Bank overdrafts</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">13,551</td>
                            <td class="end font">-</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Long term loans</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">189,343</td>
                            <td class="end font">168,387</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">202,894</td>
                            <td class="end font white font-weight-bold">168,387</td>
                        </tr>
                        <tr>
                            <td class="font black bold" colspan="3">Others</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Short term loans</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">-</td>
                            <td class="end font">1,786</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Long term loans</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">-</td>
                            <td class="end font">10</td>
                        </tr>
                        <tr class="light-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">-</td>
                            <td class="end font white font-weight-bold">1,796</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">1,196,376</td>
                            <td class="end font white font-weight-bold">1,398,724</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">ألف دينار كويتي</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font black bold" colspan="3">الشركة</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">قروض قصيرة الأجل</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">91,110</td>
                            <td class="end font">80,580</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">قروض طويلة الأجل</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">562,873</td>
                            <td class="end font">598,535</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">653,983 </td>
                            <td class="end font white font-weight-bold">679,115</td>
                        </tr>
                        <tr>
                            <td class="font black bold" colspan="3">زين السعودية</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">قروض طويلة الأجل</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">310,651</td>
                            <td class="end font">542,804</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">310,651</td>
                            <td class="end font white font-weight-bold">542,804</td>
                        </tr>
                        <tr>
                            <td class="font black bold" colspan="3">زين – الأردن</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">قروض قصيرة الأجل</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">-</td>
                            <td class="end font">6,622</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">قروض طويلة الأجل</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">28,848</td>
                            <td class="end font">-</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">28,848</td>
                            <td class="end font white font-weight-bold">6,622</td>
                        </tr>
                        <tr>
                            <td class="font black bold" colspan="3">أثير – العراق</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">سحب بنكي على المكشوف</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">13,551</td>
                            <td class="end font">-</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">قروض طويلة الأجل</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">189,343</td>
                            <td class="end font">168,387</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">202,894</td>
                            <td class="end font white font-weight-bold">168,387</td>
                        </tr>
                        <tr>
                            <td class="font black bold" colspan="3">أخرى</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">قروض قصيرة الأجل</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">-</td>
                            <td class="end font">1,786</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">قروض طويلة الأجل</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">-</td>
                            <td class="end font">10</td>
                        </tr>
                        <tr class="light-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">-</td>
                            <td class="end font white font-weight-bold">1,796</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">1,196,376</td>
                            <td class="end font white font-weight-bold">1,398,724</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>